<template>
<v-container>

  <nav>
 <v-app-bar
      app
     flat
     dense
    >
       <v-app-bar-nav-icon  @click="drawer = !drawer" >
        <v-img
          alt="Logo"
          class="mr-1"
          contain
          :src="require('../../public/img/logo.png')"
          transition="scale-transition"
          height="40"
        />
        </v-app-bar-nav-icon>
      <v-app-bar-title class="text-uppercase grey--text">
        <span class="font-weight-light">Frena</span>
        <span>Inventory</span>
      </v-app-bar-title>

      <v-spacer/>

       <v-btn v-if="!loggedIn" text color="grey" to="/login">
        <span>Συνδεση</span>
        <v-icon right>mdi-login-variant</v-icon>
      </v-btn>
       <v-btn v-if="loggedIn" text color="grey"  @click.stop="drawer2 = !drawer2">
          <v-avatar size="42">
          <img src="../../public/img/logo_fm_app.png">
          </v-avatar>
      </v-btn>
    </v-app-bar>


    <v-navigation-drawer app v-model="drawer" color="blue-grey darken-1">
      <v-list
        dense
        nav
        >
        <v-list-item v-for="link in filtLinks" :key="link.text" router :to="link.route">
          <v-list-item-action>
            <v-icon class="white--text">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list
        dense
        nav
        >
       <v-list-item v-if="loggedIn" key="12" router :to="{name: 'edit-repair', params: {repairId: 1262}}">
          <v-list-item-action>
            <v-icon class="white--text">mdi-package</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">Ιδιοκατανάλωση</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
       <v-list-item v-if="loggedIn" key="13" router to="/user/profile">
          <v-list-item-action>
            <v-icon class="white--text">mdi-cogs</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">Ρυθμίσεις</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
    </v-navigation-drawer>
 <v-navigation-drawer
      v-model="drawer2"
      right
      hover
      app
      temporary
      bottom
    >
      <template v-slot:prepend>
      <img v-if="$vuetify.breakpoint.mdAndUp || !$vuetify.breakpoint.mobile" width="250px" :src=avatarUrl @error="setFallbackAvatar">
        <v-list-item two-line>
         <v-list-item-avatar v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.mobile">
           <!-- <img src="https://randomuser.me/api/portraits/men/81.jpg"> -->
          <img :src="avatarUrl" @error="setFallbackAvatar">
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ name }}</v-list-item-title>
            <v-list-item-subtitle v-if="loggedIn">Logged In</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>

       <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.to"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
          </v-navigation-drawer>
  </nav>

</v-container>
</template>


 <script>
  export default {
  watch: { loggedIn: {
     immediate: true,
      handler(isLoggedIn) { 
        // Refresh reactive user info whenever login state changes
        const raw = localStorage.getItem("userInfo")
        this.userInfo = isLoggedIn && raw ? JSON.parse(raw) : null 
      } 
    }
   },
  computed: {
      loggedIn () {
          return this.$store.state.authentication.status.loggedIn;
      },
      scopes () {
          if (!this.$store.state.authentication.user) return [];
          return this.$store.state.authentication.user.scopes;
      },
      // name () {
      //     if (!localStorage.getItem("userInfo")) return "";
      //     return JSON.parse(localStorage.getItem("userInfo")).FullName;
      // },
      // username () {
      //     if (!localStorage.getItem("userInfo")) return "";
      //     return JSON.parse(localStorage.getItem("userInfo")).Username;
      // },
      // avatarUrl () {
      //   console.log(localStorage.getItem("userInfo"));
      //   if (!localStorage.getItem("userInfo")) return require("@/assets/default_avatar.png");
      //   const username = JSON.parse(localStorage.getItem("userInfo")).Username;
      //   console.log(username, `/img/avatar_${username}.png`);
      //   return require(`@/assets/avatar_${username}.png`);
      // },

      name() { return this.userInfo?.FullName || "" },
      username() { return this.userInfo?.Username || "" },
      avatarUrl() { 
        // If we don't have a username yet, show default
         if (!this.userInfo?.Username) return this.fallbackAvatarUrl
         const username = this.userInfo.Username
          try { // Dynamic requires can throw if file doesn't exist. Wrap in try/catch.
            return require(`@/assets/avatar_${username}.png`)
           } catch (e) { return this.fallbackAvatarUrl }
      },

      filtLinks () {
          return this.links.filter(el => this.scopes.includes(el.scope) || !el.scope);
      }
  },
data() {
  return {
    drawer: true,
    drawer2: false,
    userInfo:null,
    fallbackAvatarUrl: require("@/assets/default_avatar.png"),
    items: [
      { title: 'Home', icon: 'mdi-home-city', to: "/" },
      { title: 'My Account', icon: 'mdi-account', action: "", to: "/user/profile" },
      { title: 'Users', icon: 'mdi-account-group-outline', action: "", to: "" },
      { title: 'Αποσύνδεση', icon: 'mdi-exit-to-app', action: "", to: "/login" },
      ],
    links: [
       { text: 'Ημερολόγιο', icon: 'mdi-calendar', route: "/calendar", scope: "repairs"},
      { text: 'Οικονομικά', icon: 'mdi-finance', route: "/income", scope: "income"},
      // { text: 'Dashboard', icon: 'mdi-view-dashboard', route: "/dashboard" },
      { text: 'Βιβλίο ΑΑΔΕ', icon: 'mdi-book-open-page-variant', route: "/aade/purchases", scope: "income"},
      { text: 'Πελάτες', icon: 'mdi-account-group', route: "/customers", scope: "customers"},
      { text: 'Καρτέλες Προμηθευτών', icon: 'mdi-account-tie', route: "/distributors", scope: "suppliers" },
      { text: 'Καρτέλες Πελατών', icon: 'mdi-badge-account-horizontal', route: "/books", scope: "income" },
      { text: 'Οχήματα', icon: 'mdi-truck', route: "/vehicles", scope:  "repairs" },
      { text: 'Επισκεύες', icon: 'mdi-hammer-wrench', route: "/repairs", scope: "repairs" },
      { text: 'Τιμολόγια Αγορών', icon: 'mdi-file-document', route: "/supinvoices", scope: "suppliers" },
      { text: 'Τιμολόγια Πωλήσεων', icon: 'mdi-file-document', route: "/invoices", scope: "income" },
      { text: 'Πιστώσεις', icon: 'mdi-cash-register', route: "/debits", scope:  "income" },
      { text: 'Έξοδα', icon: 'mdi-cash-register', route: "/expenses", scope: "income" },
      { text: 'Υπόλοιπα', icon: 'mdi-cash-register', route: "/aging", scope: "income" },
      { text: 'Προσφορές', icon: 'mdi-file-document-edit', route: "/quotes", scope:  "quotes" },
  //    { text: 'Αποθήκη0', icon: 'mdi-warehouse', route: "/oldinventory", scope: "inventory"},
      { text: 'Παραγγελίες', icon: 'mdi-list-box', route: "/preorders", scope: "inventory"},
      { text: 'Αποθήκη', icon: 'mdi-warehouse', route: "/inventory", scope: "inventory"},
      { text: 'Πωλήσεις', icon: 'mdi-chart-bar-stacked', route: "/sales", scope: "inventory"},
  //    { text: 'Περί', icon: 'mdi-help-box', route: "/about"},
       { text: 'Ραντεβού', icon: 'mdi-car-clock', route: "/appointments", scope: "repairs"},
      { text: 'Εργαλεία', icon: 'mdi-calculator', route: "/utils" },
      { text: 'Δηλωση ΣΑΠ', icon: 'mdi-card-bulleted', route: "/sap", scope: "income"},
    ]
  }
  },
  methods: {
    setFallbackAvatar(event) {
      event.target.src = this.fallbackAvatarUrl;
    },
  }
}

</script>

<style>
</style>
